import { render, staticRenderFns } from "./BranchSummary.vue?vue&type=template&id=0404a057&scoped=true&"
import script from "./BranchSummary.vue?vue&type=script&lang=ts&"
export * from "./BranchSummary.vue?vue&type=script&lang=ts&"
import style0 from "./BranchSummary.vue?vue&type=style&index=0&id=0404a057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0404a057",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
